import { ReactNode } from 'react'

export interface TabBarItem {
    header: ReactNode
    body: ReactNode
    disabled?: boolean
    className?: string
}

export enum TabSize {
    Large = 'Large',
    Medium = 'Medium',
}

export enum TabType {
    Normal = 'normal',
    PinkBox = 'pink-box',
    PDPGallery = 'pdp-gallery',
}

export interface TabContextValues {
    selectedIndex: number
    changeSelectedIndex: (value: number) => void
}
